import { Component, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import templateString from './articleForm.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../data.service';
import * as moment from 'moment';
import { EnvironmentService } from '../../../environment.service';
import { Article } from '../../../models/article.model';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class ArticleFormComponent implements OnInit {
    @Output() action = new EventEmitter();
	
	public articleId: any;

	public article: any;
	public submitted: boolean;	
	public actionTitle: string;

	constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2,
		private toastr: ToastrService,
		private dataService: DataService,
		private environmentService: EnvironmentService
	) {
		this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
	}

  	ok(isValid) {
		this.submitted = true;
		
		if (isValid) {
			if (this.articleId === null) {
				this.http.post("articles", this.article).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			} else {
				this.http.put("articles/" + this.article.id, this.article).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			}
		}
  	}

  	cancel() {
		this.bsModalRef.hide();
  	}

    ngOnInit() {
		if (this.articleId === null) {
			this.actionTitle = "toevoegen";
			this.article = new Article();
		} else {
			this.actionTitle = "wijzigen";
			this.http.get("articles/" + this.articleId).subscribe(x => {
				this.article = x;
			});
		}
    }
}
